// organisms/InvoiceViewerPanel.tsx
import { Box } from '@chakra-ui/react';
import FaceliftText from '@/components/Atoms/FaceliftText';
import { FaceliftPdfViewerContainer } from '@/components/Molecules/FaceliftPdfViewerContainer/FaceliftPdfViewerContainer';
import type { Invoice } from '@/types/invoice';

interface InvoiceViewerPanelProps {
	invoice: Invoice;
	isLoading: boolean;
	url: string;
	isEmptyOrUnavailable?: boolean;
	isLoadError?: boolean;
}
const InvoiceViewerPanel = ({
	invoice,
	isLoading,
	url,
	isEmptyOrUnavailable,
	isLoadError,
}: InvoiceViewerPanelProps) => (
	<Box>
		{invoice ? (
			<>
				<FaceliftText fontSize="lg" fontWeight="600" mb={3} color={{ base: 'gray.700', _dark: 'gray.200' }}>
					Invoice #{invoice.Invoice}
				</FaceliftText>

				<FaceliftPdfViewerContainer
					isLoading={isLoading}
					url={url}
					isEmptyOrUnavailable={isEmptyOrUnavailable}
					isLoadError={isLoadError}
				/>
			</>
		) : (
			<Box
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
			>
				<FaceliftText color={{ base: 'gray.700', _dark: 'gray.200' }} fontSize="lg">
					Select an invoice from the list to view
				</FaceliftText>
			</Box>
		)}
	</Box>
);
export default InvoiceViewerPanel;